import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import { NavLink } from 'react-router-dom';

import styles from './Item.module.scss';

type ItemProps = {
  name: string;
  icon: string;
  link: string;
  notification: string | number;
  disabled?: boolean;
  disabledName?: string;
};

const ItemContent = observer<ItemProps>(({ name, icon, notification }) => (
  <>
    <img src={icon} alt={name} />
    {name.toUpperCase()}
    {notification && (
      <span className={clsx(styles.badge, 'in-row-center')}>
        {notification}
      </span>
    )}
  </>
));

const ItemContentDisabled = observer<ItemProps>(({ name, icon }) => (
  <>
    <img src={icon} alt={name} />
    {name.toUpperCase()}
  </>
));

export const Item = observer<ItemProps>(
  ({ name, icon, link, notification, disabled, disabledName = '' }) => (
    <>
      {!disabled && (
        <NavLink
          to={link}
          className={({ isActive }) =>
            clsx(styles.item, 'in-col in-v-center in-h-between', {
              [styles.active]: isActive,
            })
          }
        >
          <ItemContent
            name={name}
            icon={icon}
            notification={notification}
            link={link}
          />
        </NavLink>
      )}
      {disabled && (
        <div
          className={clsx(
            styles.item,
            'in-col in-v-center in-h-between in-color-main',
          )}
          style={{ opacity: '0.5' }}
        >
          <ItemContentDisabled
            name={disabledName}
            icon={icon}
            notification={notification}
            link={link}
          />
        </div>
      )}
    </>
  ),
);
